import throttle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';

const defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];

/**
 *
 * @param {Boolean} isAuth
 * Check if user is authorized, otherwise timer is not "used".
 * Automatically return false (Not idle) if isAuth is false.
 * @param {Function} api
 * Function to trigger if user is not idle when timer is over.
 * @param {Number} ms
 * Timer duration in milliseconds.
 * @param {Boolean} initialState
 * @param {Array} events
 * @returns
 */
// TODO: Semplificare la logica
const useIdle = (isAuth, api, ms = 60e3, initialState = true, events = defaultEvents) => {
  const [isIdle, setIsIdle] = useState(initialState);
  const [recallUseEffect, setRecallUseEffect] = useState(initialState);
  const timer = useRef();

  useEffect(() => {
    let cleanEffect = () => {};
    if (isAuth) {
      let mounted = true;
      let localState = isIdle;
      const set = (newState) => {
        if (mounted) {
          localState = newState;
          setIsIdle(newState);
        }
      };

      const onEvent = throttle(() => {
        if (localState) set(false);
      }, 50);

      const onVisibility = () => {
        if (!document.hidden) onEvent();
      };

      for (let i = 0; i < events.length; i++) window.addEventListener(events[i], onEvent);
      document.addEventListener('visibilitychange', onVisibility);

      timer.current = setTimeout(() => {
        if (!localState) api();
        else set(true);
        setIsIdle(true);
        setRecallUseEffect(!recallUseEffect);
      }, ms);

      cleanEffect = () => {
        mounted = false;
        for (let i = 0; i < events.length; i++) window.removeEventListener(events[i], onEvent);
        document.removeEventListener('visibilitychange', onVisibility);
      };
    }

    return cleanEffect;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, ms, events, recallUseEffect]);

  useEffect(() => {
    if (!isAuth && timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  }, [isAuth]);

  return isIdle;
};

export default useIdle;
